import React from "react";
import { graphql, compose } from "react-apollo";
import gql from "graphql-tag";
import DoctorCalendar from "./DoctorCalendar";
import ContentLoader from "react-content-loader";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import NextRdvNotification from "./NextRdvNotification";
import LeftArrow from "../../img/left-arrow.svg";
import RightArrow from "../../img/right-arrow.svg";

class SecretaryHome extends React.Component {
  toastId = null;

  constructor(props) {
    super(props);
    this.state = {
      activeTab: -1,
      doctors: [],
      typesRefs: [],
      arrowDirection: "right",
    };

    this.calendarContainer = React.createRef();
  }

  removeNotification = () => {
    toast.dismiss();
  };
  updateToast = () => {
    toast.update(this.toastId, {
      autoClose: 10000,
    });
  };

  addRef = (node, docId, left) => {
    this.setState((prevState) => ({
      typesRefs: {
        ...prevState.typesRefs,
        [docId]: { node, left },
      },
    }));
  };

  notify = (
    rdvTypeId,
    rdvTypeDuration,
    doctorId,
    weekId,
    baseDuration,
    daysAhead,
    modalCallback,
    minTimeAdmin,
    maxTimeAdmin
  ) => {
    if (toast.isActive(this.toastId)) {
      this.removeNotification();
      setTimeout(() => {
        this.toastId = toast(
          <NextRdvNotification
            updateToast={this.updateToast}
            modalCallback={modalCallback}
            rdvTypeId={rdvTypeId}
            rdvTypeDuration={rdvTypeDuration}
            baseDuration={baseDuration}
            daysAhead={daysAhead}
            doctorId={doctorId}
            weekId={weekId}
            minTime={minTimeAdmin}
            maxTime={maxTimeAdmin}
          />,
          {
            progressClassName: "toast-progessbar",
            className: "toast160",
            position: "top-right",
            autoClose: false,
            newestOnTop: false,
            closeButton: false,
            closeOnClick: true,
            rtl: false,
            pauseOnVisibilityChange: false,
            draggable: true,
            draggablePercent: 80,
          }
        );
      }, 500);
    } else {
      //if (!toast.isActive(this.toastId)) {
      this.toastId = toast(
        <NextRdvNotification
          updateToast={this.updateToast}
          modalCallback={modalCallback}
          rdvTypeId={rdvTypeId}
          rdvTypeDuration={rdvTypeDuration}
          baseDuration={baseDuration}
          minTime={minTimeAdmin}
          maxTime={maxTimeAdmin}
          daysAhead={daysAhead}
          doctorId={doctorId}
          weekId={weekId}
        />,
        {
          progressClassName: "toast-progessbar",
          className: "toast160",
          position: "top-right",
          autoClose: false,
          newestOnTop: false,
          closeButton: false,
          closeOnClick: true,
          rtl: false,
          pauseOnVisibilityChange: false,
          draggable: true,
          draggablePercent: 80,
        }
      );
      /*  } else {
      toast.update(this.toastId, {
        render: (
          <NextRdvNotification
            updateToast={this.updateToast}
            modalCallback={modalCallback}
            rdvTypeId={rdvTypeId}
            rdvTypeDuration={rdvTypeDuration}
            baseDuration={baseDuration}
            daysAhead={daysAhead}
            doctorId={doctorId}
            weekId={weekId}
            updated={true}
          />
        ),
        autoClose: false
      });
    }*/
    }
  };

  shouldComponentUpdate(nextProps, nextState) {
    if (
      nextProps.getAllDoctors.loading
      /*  nextProps.allSlotsQuery.loading ||
      nextProps.getCustomSlots.loading ||
      nextProps.getSpecialDays.loading*/
    ) {
      return false; //false
    }
    return true;
  }
  componentWillReceiveProps(newProps) {
    if (
      newProps.getSelectedRdv.rdvSelect.selectedDoctorId !==
      this.props.getSelectedRdv.rdvSelect.selectedDoctorId
    ) {
      this.setState({ arrowDirection: "right" });
    }

    if (!newProps.getAllDoctors.loading) {
      let docs = newProps.getAllDoctors.allUsers;

      if (this.state.doctors.length === 0) {
        if (newProps.doctorId !== null) {
          //user is a doc, rearrange list so he is first
          let ndocs = [];
          let docIndex = docs.findIndex((d) => d.id === newProps.doctorId);
          if (docIndex > 0) {
            ndocs.push(docs[docIndex]);
            for (let i = 0; i < docs.length; i++) {
              if (i !== docIndex) {
                ndocs.push(docs[i]);
              }
            }
            docs = ndocs;
          }
        }
      } else {
        docs = this.state.doctors;
      }

      /* if (
        docs.length > 2 &&
        newProps.getSelectedRdv.rdvSelect.selectedDoctorId === null
      ) {
        this.setState({ activeTab: 0, doctors: docs });
      } else */
      if (
        docs.length >= 2 &&
        newProps.getSelectedRdv.rdvSelect.selectedDoctorId === null
      ) {
        this.setState({ activeTab: -1, doctors: docs });
      } else if (newProps.getSelectedRdv.rdvSelect.selectedDoctorId !== null) {
        let activeTab = docs.findIndex((doc) => {
          return doc.id === newProps.getSelectedRdv.rdvSelect.selectedDoctorId;
        });
        this.setState({ activeTab: activeTab, doctors: docs });
      } else {
        this.setState({ activeTab: 0, doctors: docs });
      }
    }
  }

  /*openTab = i => {
    this.setState({ activeTab: i }, () => {
      if (i === -1) {
        this.handleChangeDoc(null);
      } else {
        const selectedDoc = this.state.doctors[i];
        this.handleChangeDoc(selectedDoc);
      }
    });
  };*/
  handleChangeDoc = (nselectedDoctor) => {
    let selectedDoctorId = null;
    if (nselectedDoctor !== null) {
      selectedDoctorId = nselectedDoctor.id;
    }
    let selectedRdvTypeId = null;
    let selectedRdvTypeDuration = null;
    this.props
      .updateRdvSelect({
        variables: {
          selectedDoctorId,
          selectedRdvTypeId,
          selectedRdvTypeDuration,
        },
      })
      .catch((e) => {
        console.error("update local state", e);
      });
  };

  renderOpenTab = (i, showTitle, typesStyle = "is-fixed-types") => {
    /*  let typesStyle = "is-fixed-types";
    if (this.state.doctors.length === 2) {
      if (i === 0) {
        typesStyle = "is-fixed-types is-fixed-types-left";
      }
      if (i === 1) {
        typesStyle = "is-fixed-types is-fixed-types-right";
      }
    }*/
    let currentId = this.props.getSortedDocs.sortedDocs.sortedDocs[i];
    if (!currentId) {
      currentId = this.state.doctors[i].id;
    }
    let currentDoc = this.state.doctors.find((d) => d.id === currentId);

    let marginTop = "-10px";
    let typesStyleLeft = i > 0 ? 50 * i : 0;
    let typesStyleWidth = this.state.doctors.length > 1 ? 49 : 100;
    if (typesStyle !== "is-fixed-types") {
      //marginTop = "0px";
      typesStyleLeft = 0;
      typesStyleWidth = 100;
    }

    let title =
      this.state.activeTab === -1 ? (
        <h2 className="title is-size-6	 has-text-centered">{currentDoc.name}</h2>
      ) : null;
    return (
      <div
        className="column "
        style={{
          marginTop: marginTop,
          minWidth: "calc(50% - 72px)",
        }}
      >
        <DoctorCalendar
          addRef={this.addRef}
          toggleChatModal={this.props.toggleChatModal}
          userName={this.props.userName}
          typesStyle={typesStyle}
          typesStyleLeft={typesStyleLeft}
          typesStyleWidth={typesStyleWidth}
          title={title}
          notify={this.notify}
          removeNotification={this.removeNotification}
          showTitle={showTitle}
          slots={this.props.slots}
          doctorId={currentDoc.id}
          options={currentDoc.options}
          week={currentDoc.week}
          allSlotTypes={currentDoc.slotTypes}
          selectedRdvDate={this.props.getSelectedRdv.rdvSelect.selectedDate}
          selectedView={this.props.getSelectedRdv.rdvSelect.selectedView}
          /*          allSlots={this.props.allSlotsQuery.allSlots}
          refetchCustomSlots={this.props.getCustomSlots.refetch}
          allCustomSlots={this.props.getCustomSlots.allCustomSlots}
          allSpecialDays={this.props.getSpecialDays.allSpecialDays}*/
        />
      </div>
    );
  };

  handleScroll = (e) => {
    for (const element in this.state.typesRefs) {
      const node = this.state.typesRefs[element].node;
      const left = this.state.typesRefs[element].left;

      node.style.left = `calc(${left} - ${e.currentTarget.scrollLeft}px`;
    }
    //  arrowDirection;
    if (
      e.target.scrollLeft >=
      e.target.scrollWidth - e.target.offsetWidth - 50
    ) {
      this.setState({ arrowDirection: "left" });
    }
    if (e.target.scrollLeft <= 50) {
      this.setState({ arrowDirection: "right" });
    }

    // this.typesContainer.current.scrollLeft = e.currentTarget.scrollLeft;
    //  scrollTypesContainre(e.currentTarget.scrollLeft)
    // console.log(this.calendarsContainer.current.clientWidth);
    /*
    const node = ReactDOM.findDOMNode(this);
    const asideElement = node.querySelector('aside');
    const mainElement = node.querySelector('main');
    

    asideElement.scrollTop = mainElement.scrollTop;
    */
  };

  render() {
    if (this.props.getAllDoctors.loading || this.state.doctors.length === 0) {
      return (
        <div className="columns  is-centered">
          <div className="column is-4 has-text-centered">
            <p />
            <ContentLoader type="facebook" />
          </div>
        </div>
      );
    }
    return (
      <React.Fragment>
        {this.state.activeTab === -1 ? (
          <div
            className="columns is-space-between"
            ref={this.calendarContainer}
            onScroll={this.handleScroll}
            style={{
              overflowX: "scroll",
              overflowY: "hidden",
              position: "relative",
              scrollBehavior: "smooth",
            }}
          >
            {this.state.doctors.length > 2 &&
              this.state.arrowDirection === "right" && (
                <div
                  onClick={(e) => {
                    this.calendarContainer.current.scrollLeft = this.calendarContainer.current.scrollWidth;
                  }}
                  style={{
                    position: "fixed",
                    top: "50px",
                    right: "1rem",
                    padding: 15,
                    zIndex: 5,
                    cursor: "pointer",
                  }}
                >
                  <img alt="Right" src={RightArrow} width={45} />
                </div>
              )}
            {this.state.doctors.length > 2 &&
              this.state.arrowDirection === "left" && (
                <div
                  onClick={(e) => {
                    this.calendarContainer.current.scrollLeft = 0;
                  }}
                  style={{
                    position: "fixed",
                    top: "50px",
                    left: "2rem",
                    padding: 15,
                    zIndex: 5,
                    cursor: "pointer",
                  }}
                >
                  <img alt="Left" src={LeftArrow} width={45} />
                </div>
              )}

            {this.state.doctors.map((doc, i) => (
              <React.Fragment>
                {this.renderOpenTab(i, false, "is-fixed-types")}
                {i < this.state.doctors.length - 1 && (
                  <div className="is-divider-vertical" />
                )}
              </React.Fragment>
            ))}
          </div>
        ) : null}
        {this.state.activeTab >= 0 ? (
          <div
            className="columns is-space-between "
            style={{
              marginTop: -8,
            }}
          >
            {this.renderOpenTab(
              this.state.activeTab,
              true,
              "is-fixed-types-single"
            )}
          </div>
        ) : null}
      </React.Fragment>
    );
  }
}

const GET_ALL_DOCTORS_QUERY = gql`
  query {
    allUsers(filter: { role: DOCTOR }) {
      id
      name
      role
      options {
        daysAhead
        baseDuration
        minTimeAdmin
        maxTimeAdmin
      }
      slotTypes(orderBy: index_ASC) {
        id
        name
        duration
        role
        infos
        doctor {
          id
        }
      }
      week {
        id
        days {
          id
          day
          dayTemplate {
            id
            name
            hours {
              id
              time
              slotTypes {
                id
                name
              }
            }
          }
        }
      }
    }
  }
`;
const UPDATE_RDV_SELECT = gql`
  mutation updateRDVSelect(
    $selectedDate: Int
    $selectedPatientId: String
    $selectedDoctorId: String
    $selectedRdvTypeId: String
    $selectedRdvTypeDuration: Int
  ) {
    updateRDVSelect(
      selectedRdvTypeId: $selectedRdvTypeId
      selectedRdvTypeDuration: $selectedRdvTypeDuration
      selectedDoctorId: $selectedDoctorId
      selectedDate: $selectedDate
      selectedPatientId: $selectedPatientId
    ) @client
  }
`;
const GET_SELECTED_RDV_DATE = gql`
  query {
    rdvSelect @client {
      selectedDate
      selectedDoctorId
      selectedView
    }
  }
`;

const GET_SORTEDDOCS = gql`
  query {
    sortedDocs @client {
      sortedDocs
    }
  }
`;

export default compose(
  graphql(GET_ALL_DOCTORS_QUERY, {
    name: "getAllDoctors",
  }),
  graphql(GET_SELECTED_RDV_DATE, {
    name: "getSelectedRdv",
    options: { fetchPolicy: "cache-only" },
  }),
  graphql(UPDATE_RDV_SELECT, {
    name: "updateRdvSelect",
  }),
  graphql(GET_SORTEDDOCS, {
    name: "getSortedDocs",
    options: { fetchPolicy: "cache-only" },
  })
)(SecretaryHome);



// WEBPACK FOOTER //
// ./src/components/utilities/SecretaryHome.js